import { isAssignmentLimitReachedError } from '@breakoutlearning/firebase-repository/sources-of-truth/assignmentLimit'
import type { useTranslationTyped } from 'i18n/i18n'

type TT = ReturnType<typeof useTranslationTyped>['tt']

/**
 * The instructor-facing message for a publish blocked by the section pass's
 * assignment limit (BL-5134), or undefined for any other error.
 */
export function assignmentLimitMessage(
  tt: TT,
  error: unknown
): string | undefined {
  if (!isAssignmentLimitReachedError(error)) return undefined
  if (error.adding > 1) {
    return tt.instructor_assignment.assignment_limit_reached_bulk({
      remaining: Math.max(0, error.limit - error.active),
      adding: error.adding,
    })
  }
  return tt.instructor_assignment.assignment_limit_reached({
    limit: error.limit,
    active: error.active,
  })
}
